import React, { useState, useEffect, useRef } from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { buildApiUrl } from '../../config/api';
import 'bootstrap/dist/css/bootstrap.min.css';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import 'react-loading-skeleton/dist/skeleton.css'


export default function ReleaseCarousel({onConditionChange}) {
  const [songs, setSongs] = useState([]);
  const [index, setIndex] = useState(0);
  const [cycling, setCycling] = useState(true);
  const [loading, setLoading] = useState(true);

  // Songs von der API laden
  useEffect(() => {
    const fetchSongs = async () => {
      try {
        const endpoint = buildApiUrl('/api/release');
        const response = await axios.get(endpoint);

        if (!Array.isArray(response.data)) {
          console.warn('Unexpected /api/release payload (expected array):', {
            endpoint,
            status: response.status,
            payloadType: typeof response.data,
            preview: typeof response.data === 'string' ? response.data.slice(0, 120) : response.data
          });
        }

        setSongs(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        console.error('Error fetching songs:', {
          endpoint: buildApiUrl('/api/release'),
          message: err?.message,
          status: err?.response?.status,
          data: err?.response?.data
        });
        setSongs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchSongs();
  }, []);
  useEffect(() => {
    if (!loading) {
      onConditionChange(songs.length > 0);
    }
  }, [loading, songs, onConditionChange]);


  const handleSelect = (selectedIndex) => {
    if((selectedIndex-index + songs.length) % songs.length !== 1){
      setCycling(false);
      setTimeout(() => {
        setCycling(true);
      }, 7000);
    }
    setIndex(selectedIndex);
  };
  if (loading) {
    return (
    <section id="releases" className='mysection'>
      <SkeletonTheme 
        baseColor="var(--home-skeleton-base-color)" 
        highlightColor="var(--home-skeleton-highlight-color)"
      >
        {/* Überschrift Skeleton */}
        <div className="text-center mb-3">
          <Skeleton width={200} height={40} /> {/* Höhe ähnlich wie h2 */}
        </div>
        
        {/* Bild Skeleton */}
        <div className="d-flex justify-content-center">
          <Skeleton width={300} height={300} />
        </div>
        
        {/* Text Skeleton */}
        <div className="mt-2 text-center">
          <Skeleton width={200} height={20} />
          <Skeleton width={100} height={15} />
        </div>
      </SkeletonTheme>
    </section>

    );
  }

  return (
    <section id="releases" className='mysection'>
    <h2 className='heading'>RELEASES</h2>
    <Carousel
      className="myCarousel"
      activeIndex={index}
      onSelect={handleSelect}
      interval={cycling ? 3000 : null}
      controls={false}
      indicators={true}
      pause={false}
    >
      {songs.map((song, idx) => (
        <Carousel.Item key={idx} style={{ cursor: 'pointer' }}>
          <Link
  to="#"
  onClick={(e) => {
    e.preventDefault();
    window.open(`/song/${song.id}`, "_blank", "noopener,noreferrer");
  }}
  className="d-block text-center"
>
            <img
              className="d-block mx-auto"
              src={song.coverImageUrl}
              alt={song.title}
              style={{ width: '300px', height: '300px', objectFit: 'cover' }}
            />
            <div className="mt-2">
              <h5>{song.title}</h5>
              <p style={{color: 'var(--home-font-color-tert)'}}>{new Date(song.dateAdded).getFullYear()}</p>
            </div>
          </Link>
        </Carousel.Item>

      ))}
    </Carousel>
    </section>
  );
}
